import { apiPost } from './index';

const FOCALPOINTS_API_URI = "https://api.focalpoints.co.za/api/";

export interface ContactUsRequestFP {
    Fullname: string;
    CompanyName: string;
    EmailAddress: string;
    ContactNumber: string;
    How: string;
    LookingFor: string;
    Message: string;
}

const focalPoints = {
    contactUs: async (body: ContactUsRequestFP) => {
        const data = await apiPost(`${FOCALPOINTS_API_URI}/corporate/contactus`, body);
        return data;
    }
}

export default focalPoints;